import { render } from "./left.vue?vue&type=template&id=2b5a57a1&scoped=true"
import script from "./left.vue?vue&type=script&lang=js"
export * from "./left.vue?vue&type=script&lang=js"

import "./left.vue?vue&type=style&index=0&id=2b5a57a1&scoped=scoped&lang=css"
script.render = render
script.__scopeId = "data-v-2b5a57a1"

export default script